import * as React from 'react'
import { Grid, Col, Row } from 'react-bootstrap';
import  SelectCamera  from "../../components/SelectCamera/SelectCamera"


export const SelectCameraInner = (props: any) =>
    <div>
        <Grid bsClass="container">
            <Row>
              
                <Col xs={12} md={12}>
                    <SelectCamera/>
                </Col>
            </Row>
        
        </Grid>
    </div>


// WEBPACK FOOTER //
// ./src/Routes/SelectCamera/SelectCameraInner.tsx